import { WorkflowSidebarButton } from '@salecycle/ui-component-library';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { NodeIds } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';
import { useBranchControl } from './hooks/useBranchControl';

export const branchControlDragId = 'branch-control';

export function BranchControlsButton() {
  const { t } = useTranslation('campaigns');

  const { addToFlow, onBranchControlDragged, hideDropNodes } = useBranchControl();

  const onDrop = useCallback(
    (dropLocation: string) => {
      addToFlow(dropLocation ?? NodeIds.dropzone);
    },
    [addToFlow],
  );

  const onDrag = useCallback(() => {
    onBranchControlDragged();
  }, [onBranchControlDragged]);

  const onDropFallback = useCallback(() => {
    hideDropNodes();
  }, [hideDropNodes]);

  return (
    <WorkflowSidebarButton
      icon="split"
      aria-label={t('onsite.editor.workflow.branchControls.messageAria')}
      dragId={branchControlDragId}
      onDrag={onDrag}
      onDrop={onDrop}
      onDropFallback={onDropFallback}
      onMouseOver={onDrag}
      onMouseOut={onDropFallback}
    >
      {t('onsite.editor.workflow.branchControls.message')}
    </WorkflowSidebarButton>
  );
}
